import { nullishToOptional } from "../helpers";
import { z } from "zod";
export const DesignSystemVersion = z.object({
    id: z.string(),
    version: z.string(),
    createdAt: z.coerce.date(),
    designSystemId: z.string(),
    name: z.string(),
    comment: z.string(),
    isReadonly: z.boolean(),
    changeLog: z.string(),
    parentId: z.string().optional(),
    isDraftsFeatureAdopted: z.boolean(),
});
// Jobs
export const VersionCreationJobStatus = z.enum([
    "Success",
    "InProgress",
    "Error",
]);
export const VersionCreationJob = z.object({
    id: z.string(),
    version: z.string(),
    designSystemId: z.string(),
    designSystemVersionId: nullishToOptional(z.string()),
    status: VersionCreationJobStatus,
    errorMessage: nullishToOptional(z.string()),
});
